// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Jio1bvVjV4EiOTun {
  padding-bottom: 96px;
}

.Jio1bvVjV4EiOTun a {
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Manager/components/StationItems.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".pageWrapper {\r\n  padding-bottom: 96px;\r\n}\r\n\r\n.pageWrapper a {\r\n  text-decoration: underline;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var pageWrapper = `Jio1bvVjV4EiOTun`;
export default ___CSS_LOADER_EXPORT___;
